import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { IconButton, Tooltip } from "@mui/material";
import { useCallback } from "react";

/**
 * A small arrow icon button that copies address fields from one form section to another
 */
export const AddressCopyButton = ({
    form,
    sourcePrefix="",
    targetPrefix="",
    sourceSuffix="",
    targetSuffix="",
    fields,
    onCopy,
    tooltipText,
    ...iconButtonProps
}) => {
    const { watch, setValue } = form;

    const handleCopy = useCallback(() => {
        // Get all source values
        const sourceValues = {};
        const targetValues = {};

        fields.forEach((field) => {
            const sourceValue = watch(`${sourcePrefix}${field}${sourceSuffix}`);
            sourceValues[field] = sourceValue;

            // Set the target value
            const targetFieldName = `${targetPrefix}${field}${targetSuffix}`;
            setValue(targetFieldName, sourceValue);
            targetValues[targetFieldName] = sourceValue;
        });

        // Call the onCopy callback with all values if provided
        if (onCopy) {
            onCopy(targetValues);
        }
    }, [watch, setValue, sourcePrefix, targetPrefix, sourceSuffix, targetSuffix, fields, onCopy]);

    return (
        <Tooltip title={tooltipText}>
            <IconButton onClick={handleCopy} size="small" color="primary" {...iconButtonProps}>
                <ArrowForwardIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};
